import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getNotifications as getNotificationsApi,
    markNotificationRead as markNotificationReadApi,
    markAllNotificationsRead as markAllNotificationsReadApi,
    getUnreadNotificationsCount as getUnreadNotificationsCountApi,
} from "../../helpers/backend_helper";

export interface GetNotificationsParams {
    page?: number;
    pageSize?: number;
    limit?: number;
    perPage?: number;
    per_page?: number;
    append?: boolean;
    [key: string]: any;
}

export const getNotifications = createAsyncThunk(
    "notifications/list",
    async (params?: GetNotificationsParams) => {
        try {
            const response = await getNotificationsApi(params ?? {});
            return response;
        } catch (error: any) {
            throw error;
        }
    }
);

export const markNotificationRead = createAsyncThunk(
    "notifications/markRead",
    async ({ notificationId }: { notificationId: string | number }) => {
        try {
            const response = await markNotificationReadApi(notificationId);
            return { notificationId, response };
        } catch (error: any) {
            throw error;
        }
    }
);

export const markAllNotificationsRead = createAsyncThunk("notifications/markAllRead", async () => {
    try {
        const response = await markAllNotificationsReadApi();
        return response;
    } catch (error: any) {
        throw error;
    }
});

export const getUnreadNotificationsCount = createAsyncThunk("notifications/unreadCount", async () => {
    try {
        const response = await getUnreadNotificationsCountApi();
        return response;
    } catch (error: any) {
        throw error;
    }
});
